/* =========================================================================
   Grivet Shoe Quiz — Klaviyo integration
   Fires all 12 events from the dev plan + wires identify() at email capture.
   Uses the legacy _learnq.push() API because that's what the existing snippet
   on grivetoutdoors.com exposes (company_id=YxNnuy).
   ========================================================================= */
(function () {
  'use strict';

  function queue() {
    window._learnq = window._learnq || [];
    return window._learnq;
  }

  function push(payload) {
    try { queue().push(payload); } catch (e) { /* swallow — Klaviyo snippet may be blocked */ }
  }

  function track(event, properties) {
    push(['track', event, properties || {}]);
  }

  function identify(traits) {
    push(['identify', traits || {}]);
  }

  function mileageMidpoint(q6) {
    return {
      vol_1_10: 5, vol_11_25: 18, vol_26_40: 33, vol_41_plus: 50, vol_new: 0,
      hike_rare: 0, hike_monthly: 0, hike_weekly: 0, hike_thru: 0,
      life_light: 0, life_med: 0, life_heavy: 0
    }[q6] || 0;
  }

  var ACTIVITY_LABELS = {
    run_road: 'road running', run_trail: 'trail running',
    hike: 'hiking', lifestyle: 'walking', gift: 'gift shopping'
  };

  function flattenAnswers(a) {
    return {
      grivet_primary_activity: a.q1 || null,
      grivet_primary_activity_label: ACTIVITY_LABELS[a.q1] || 'your training',
      grivet_surface: a.q2 || null,
      grivet_arch_type: a.q3 || null,
      grivet_loved_brands: extractBrands(a.q4 && a.q4.loved),
      grivet_disliked_brands: extractBrands(a.q4 && a.q4.disliked),
      grivet_quiz_newbie: !!(a.q4 && a.q4.newbie),
      grivet_pain_points: (a.q5 || []).filter(function (f) { return /^pain_/.test(f); }),
      grivet_goals: (a.q5 || []).filter(function (f) { return /^goal_/.test(f); }),
      grivet_weekly_volume: a.q6 || null,
      grivet_weekly_volume_midpoint: mileageMidpoint(a.q6),
      grivet_cushion_preference: a.q7 && a.q7.cushion,
      grivet_feel_preference: a.q7 && a.q7.feel,
      grivet_drop_preference: (a.q7 && a.q7.drop) || null,
      grivet_gender_fit: a.q8 && a.q8.gender,
      grivet_size: a.q8 && a.q8.size,
      grivet_width: a.q8 && a.q8.width
    };
  }

  function extractBrands(text) {
    if (!text) return [];
    var s = String(text).toLowerCase();
    var known = ['brooks','hoka','saucony','on running','asics','altra','topo','mizuno','new balance','nike','adidas','salomon','merrell'];
    var out = [];
    known.forEach(function (b) {
      if (s.indexOf(b) !== -1) {
        out.push(b === 'on running' ? 'On Running' : b.replace(/\b\w/g, function (c) { return c.toUpperCase(); }));
      }
    });
    return Array.from(new Set(out));
  }

  var Quiz = {
    /* ---- event 1 ---- */
    started: function (ctx) {
      track('Started Shoe Quiz', {
        quiz_version: ctx.version || '1.0',
        landing_source: document.referrer || null,
        device: isMobile() ? 'mobile' : 'desktop',
        detected_region: ctx.tier || null,
        detected_city: (ctx.detected && ctx.detected.city) || null,
        detected_state: (ctx.detected && ctx.detected.region) || null
      });
    },
    /* ---- event 2 ---- */
    answered: function (questionId, answer, timeMs) {
      track('Answered Quiz Question', {
        question_id: questionId,
        question_number: progressNum(questionId),
        answer_id: answer,
        time_on_question_ms: timeMs || 0
      });
    },
    /* ---- event 3 ---- */
    abandoned: function (ctx) {
      var lastAnswered = ctx.stack && ctx.stack[ctx.stack.length - 1];
      track('Abandoned Shoe Quiz', {
        last_question_answered: lastAnswered,
        answers_so_far: JSON.stringify(ctx.answers || {}),
        quiz_version: ctx.version || '1.0'
      });
    },
    /* ---- event 4 ---- */
    completed: function (ctx, top3, profileName) {
      var top = top3 && top3[0];
      track('Completed Shoe Quiz', Object.assign({}, flattenAnswers(ctx.answers || {}), {
        grivet_fit_profile_name: profileName,
        grivet_top_3_ids: (top3 || []).map(function (s) { return String(s.shoe.id); }),
        grivet_top_3_skus: (top3 || []).map(function (s) {
          var v = (s.shoe.variants || []).find(function (x) { return x.available; });
          return v ? v.sku : null;
        }),
        grivet_top_match_sku: top && top.shoe.variants && top.shoe.variants[0] ? top.shoe.variants[0].sku : null,
        grivet_quiz_completed_at: new Date().toISOString(),
        grivet_quiz_version: ctx.version || '1.0'
      }));
    },
    /* ---- event 5 ---- */
    emailCaptured: function (ctx, email, smsOptIn, phone, top3, profileName) {
      var shoeDetails = {};
      (top3 || []).slice(0, 3).forEach(function (s, i) {
        var n = i + 1;
        var v = (s.shoe.variants || []).find(function (x) { return x.available; });
        shoeDetails['grivet_top_' + n + '_name']  = s.shoe.title || null;
        shoeDetails['grivet_top_' + n + '_brand'] = s.shoe.brand || null;
        shoeDetails['grivet_top_' + n + '_image'] = s.shoe.image || null;
        shoeDetails['grivet_top_' + n + '_url']   = s.shoe.url ? (/^https?:\/\//.test(s.shoe.url) ? s.shoe.url : 'https://www.grivetoutdoors.com' + s.shoe.url) : null;
        shoeDetails['grivet_top_' + n + '_price'] = (typeof s.shoe.price === 'number') ? s.shoe.price.toFixed(2) : null;
        shoeDetails['grivet_top_' + n + '_sku']   = v ? v.sku : null;
      });
      var baseTraits = Object.assign({
        $email: email,
        $consent: ['email'].concat(smsOptIn && phone ? ['sms'] : [])
      }, flattenAnswers(ctx.answers || {}), shoeDetails, {
        grivet_fit_profile_name: profileName,
        grivet_top_3_skus: (top3 || []).map(function (s) {
          var v = (s.shoe.variants || []).find(function (x) { return x.available; });
          return v ? v.sku : null;
        }),
        grivet_top_match_sku: top3 && top3[0] && top3[0].shoe.variants && top3[0].shoe.variants[0] ? top3[0].shoe.variants[0].sku : null,
        grivet_quiz_completed_at: ctx.completedAt || new Date().toISOString(),
        grivet_quiz_version: ctx.version || '1.0',
        grivet_detected_region: ctx.tier || 'national',
        grivet_detected_city: (ctx.detected && ctx.detected.city) || null,
        grivet_detected_state: (ctx.detected && ctx.detected.region) || null
      });
      if (smsOptIn && phone) baseTraits.$phone_number = phone;

      // Mint a unique one-time discount code, then identify with it included so
      // Flow 1's email can render {{ person.grivet_discount_code }} on send.
      fetch('https://webhook-handler-two.vercel.app/quiz/assign-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      }).then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (res) {
          var traits = Object.assign({}, baseTraits);
          if (res && res.code) traits.grivet_discount_code = res.code;
          identify(traits);
          track('Email Captured from Quiz', {
            email: email,
            discount_code_issued: (res && res.code) || null,
            sms_opted_in: !!smsOptIn
          });
        });
    },
    /* ---- event 6 ---- */
    emailSkipped: function (profileName) {
      track('Skipped Email Gate', { fit_profile_name: profileName });
    },
    /* ---- event 7 ---- */
    viewedResults: function (top3) {
      track('Viewed Quiz Results', {
        top_3_ids: (top3 || []).map(function (s) { return String(s.shoe.id); })
      });
    },
    /* ---- event 8 ---- */
    clickedRecommendation: function (shoe, position, type) {
      track('Clicked Quiz Recommendation', {
        shoe_id: String(shoe.id),
        shoe_sku: (shoe.variants && shoe.variants[0] && shoe.variants[0].sku) || null,
        brand: shoe.brand,
        card_position: position,
        recommendation_type: type
      });
    },
    /* ---- event 9 ---- */
    addedShoeToCart: function (shoe, variant, pickup) {
      track('Added Quiz Shoe to Cart', {
        shoe_id: String(shoe.id),
        shoe_sku: variant && variant.sku,
        variant_id: variant && variant.id,
        price: shoe.price,
        pickup_or_ship: pickup ? 'pickup' : 'ship'
      });
    },
    /* ---- event 10 ---- */
    addedBundleToCart: function (items, total) {
      track('Added Quiz Bundle to Cart', {
        bundle_items: items,
        bundle_total: total
      });
    },
    /* ---- event 11 ---- */
    bookedFitting: function (store, datetime) {
      track('Booked In-Store Fitting', {
        store_location: store,
        appointment_datetime: datetime
      });
    },
    /* ---- event 12 ---- */
    retook: function (previousName, newName, daysSince) {
      track('Retook Shoe Quiz', {
        previous_fit_profile_name: previousName,
        new_fit_profile_name: newName,
        days_since_last: daysSince
      });
    }
  };

  function progressNum(id) {
    return { q1: 1, q2a: 2, q2b: 2, q2c: 2, q2d: 2, q2e: 2, q3: 3, q4: 4, q5: 5, q6: 6, q7: 7, q8: 8 }[id] || 0;
  }
  function isMobile() {
    return /Mobi|Android|iPhone/i.test(navigator.userAgent || '');
  }

  window.GrivetQuizKlaviyo = Quiz;
})();
